<template>
    <TprmModal
        title="Rename conversation"
        size="default"
        :open="true"
        :allow-close="true"
        :close-on-backdrop="true"
        :show-close-icon="true"
        @close="$emit('close')"
    >
        <TextInput
            id="EvieRenameConversationModal__title"
            label="Title"
            :value="localTitle"
            :disabled="saving"
            :error="error"
            @input="(e) => localTitle = e.target.value"
        />
        <template #footer>
            <NewButton variant="flat" color="neutral" type="button" @click="$emit('close')">
                Cancel
            </NewButton>
            <NewButton
                color="primary"
                :disabled="saving || !localTitle.trim()"
                @click="$emit('submit', localTitle.trim())"
            >
                Update
            </NewButton>
        </template>
    </TprmModal>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';
    import TextInput from '@/modules/dynamic-form/components/style-inputs/text-input/TextInput.vue';

    // PRODUCT-26110 QA fixes4: declares every event this component `$emit`s -- without a
    // declared `emits`, Vue 3 warns "Component emitted event 'close'/'submit' but it is
    // neither declared in the emits option nor as an 'onClose'/'onSubmit' prop" every
    // time it fires.
    export default defineComponent({
        name: 'EvieRenameConversationModal',
        components: { TprmModal, NewButton, TextInput },
        props: {
            currentTitle: { type: String, default: '' },
            saving: { type: Boolean, default: false },
            error: { type: String, default: '' },
        },
        emits: [ 'close', 'submit' ],
        data() {
            return { localTitle: this.currentTitle as string };
        },
    });
</script>
